import { useDataTableParamState } from "@/common/hooks/useDataTableParamState";
import { getDefaultColumnStates } from "@/common/utils/datatable";
import { defaultUserColumns } from "@/company/components/UsersTable";
import { SegmentDTO } from "@reflag/shared/segmentAPI";
import { UsersSortByColumn } from "@reflag/shared/userAPI";

export const useUsersTableState = (segment: SegmentDTO) => {
  // Load persisted sorting and column states from segment.
  const initialSorting = segment.columnSortKey
    ? [
        {
          id: segment.columnSortKey as UsersSortByColumn,
          desc: segment.columnSortDesc ?? true,
        },
      ]
    : [
        {
          id: "name" as UsersSortByColumn,
          desc: false,
        },
      ];

  // Create table state from view data and url params.
  const tableState = useDataTableParamState<
    UsersSortByColumn,
    UsersSortByColumn
  >({
    sorting: initialSorting,
    columnStates: getDefaultColumnStates(defaultUserColumns),
    urlPrefix: "users.",
  });

  return {
    ...tableState,
    isDirty: false, // no storing user table state yet
    onReset: () => {
      tableState.onReset();
    },
  };
};
